import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import CreateAccountForm from "modules/auth/create-account-form";
import Actions from "modules/auth/auth-actions";
import { getLocale } from "modules/i18n/locale-selectors";

class CreateAccountPage extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    email: PropTypes.string,
    onChangeEmail: PropTypes.func.isRequired,
    onFacebookSignUp: PropTypes.func.isRequired
  };

  render() {
    const { onSubmit, email, onChangeEmail, onFacebookSignUp } = this.props;
    return (
      <Fragment>
        <h2 className="sub-heading">
          <FormattedMessage id="sign-up.create-account.header" />
        </h2>
        <CreateAccountForm
          onSubmit={onSubmit}
          initialValues={{ email }}
          onChangeEmail={onChangeEmail}
          onFacebookSignUp={onFacebookSignUp}
        />
      </Fragment>
    );
  }
}

const mapState = state => ({
  language: getLocale(state)
});
const mapDispatchToProps = {
  onSubmit: Actions.Creators.signUp,
  onFacebookSignUp: Actions.Creators.signUpFacebook
};

export default connect(
  mapState,
  mapDispatchToProps
)(CreateAccountPage);



// WEBPACK FOOTER //
// ./src/modules/auth/create-account-page.js